import React, { useState } from 'react';
import { HamburgerButton, CloseSmall } from '@icon-park/react';
import styles from './Header.module.css';

function Header({ onLoginClick, isLoggedIn, onHomeClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogin = () => {
    onLoginClick();
    handleCloseMenu();
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    handleCloseMenu();
    // 如果有 onHomeClick 回调，优先使用它（用于关闭个人中心等）
    if (onHomeClick) {
      onHomeClick();
    } else {
      // 否则使用默认行为：跳转到首页或滚动到顶部
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  return (
    <header className={`${styles.header} ${isMenuOpen ? styles.headerOverlay : ''}`}>
      <div className={`${styles.headerContainer} container`}>
        <a
          className={styles.logo}
          href="#"
          aria-label="数字标签内测官网"
        >
          <span className={styles.logoText}>
            <strong>数字标签内测</strong>
            <small>Digital Label Beta</small>
          </span>
        </a>
        <button
          className={styles.menuToggle}
          type="button"
          aria-expanded={isMenuOpen}
          aria-controls="primary-nav"
          onClick={handleToggleMenu}
        >
          {isMenuOpen ? (
            <CloseSmall theme="outline" size={24} fill="#2563EB" strokeWidth={3} />
          ) : (
            <HamburgerButton theme="outline" size={24} fill="#2563EB" strokeWidth={3} />
          )}
        </button>
        <nav id="primary-nav" className={`${styles.nav} ${isMenuOpen ? styles.isOpen : ''}`}>
          <div className={styles.navLinks}>
            <a href="/" onClick={handleHomeClick}>首页</a>
          </div>
          <button className={styles.loginBtn} onClick={handleLogin}>
            {isLoggedIn ? '个人中心' : '登录/注册'}
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
